import {getVoiceRecogKey} from '@/api/common.js'
const _IFlyLat = {} // 语音实例
let iflylatSerStatus = false, // 识别服务的状态
    customMethod = null, // 包含回调方法的自定义对象
    isSupport = true, // 浏览器支持的状态
    isTemporary = false, // 兼容通过邀请登录的用户 可调用接口
    IFlyLat = null, // 暂存实例对象
    restart = false, // 重新获取密钥后是否开启识别
    voiceToken = '',
    voiceUid = '',
    isSuccess = true, // 获取语音识别密钥接口是否返回数据
    isRestart = false, // 是否重新建立语音识别链接
    iatData = {};
function getVoiceTonken() {
    isSuccess = false
    getVoiceRecogKey({},isTemporary).then(res => {
        if(res.data.code == 1000) {
            voiceToken = res.data.data.key
            voiceUid = res.data.data.uid
            if(isRestart) {
                speedService()
            }
        }
        isSuccess = true
    }).catch((e)=> {
        isSuccess = true
    })
}
function speedService() { // 建立语音转文字初始化
    if(process.env.srconfig === "prod") {
        iatData = {
            "uid": voiceUid,
            "token": voiceToken
        }
    }else{
        iatData = {
            "serverUrl": "wss://odr-asr.odrcloud.cn/ws2/testsczczc?v=2.0.1",
            "uid": voiceUid,
            "token": voiceToken
        }
    }
    IFlyLat = new IFlyIatSession({
        "params": iatData,
        "callback": {
            "onResult": function(result) {
                if (result == '' || result == null) {
                } else {
                    // 传入回调方法名为sendMessage
                    customMethod.sendMessage(result)
                }
            },
            "onVolume": function(volume) {
                // 音量
            },
            "onError": function(code,msg) {
                customMethod.onError(code,msg)
                console.log("错误",code,msg)
            },
            "onProcess": function(status) {
                switch (status) {
                    case 'onStart':
                        iflylatSerStatus = true;
                        console.log("服务初始化。。。")
                        break;
                    case 'normalVolume':
                    case 'started':
                        console.log("倾听中。。。")
                        break;
                    case 'onStop':
                        console.log("等待结果。。。")
                        break;
                    case 'lowVolume':
                        console.log("倾听中。。。（声音过小）")
                        break;
                    default:
                        console.log("结束")
                }
            }
        }
    });
    if (!IFlyLat.isSupport()) {
        Vue.prototype.$alert('当前浏览器不支持语音转文字', '温馨提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'button_primary',
            showClose:false,
            customClass: 'meetbox',
            callback: action => {
                history.back()
            }
        });
        isSupport = false
        return;
    }
    if(restart) {
        IFlyLat.start()
    }
}
_IFlyLat.init =  function(custom,temporary) { // 初始实例化
    if(temporary) {
        isTemporary = true
    }
    if (custom) {
        customMethod = custom
    }
    if(voiceToken&&voiceUid) {
        isRestart = false
        speedService()
    }else {
        isRestart = true
        if(isSuccess) {
            getVoiceTonken()
        }
    }
}
_IFlyLat.IFlyLatPlay =  function() { // 开始识别
    if(isSupport) {
        if(IFlyLat) {
            IFlyLat.start()
        }else{
            restart = true
            this.init()
        }
    }
}
_IFlyLat.IFlyLatStop = function() { // 停止识别
    IFlyLat.pause()
}
_IFlyLat.IFlyLatKill = function() { // 销毁退出
    if(IFlyLat) {
        // IFlyLat.pause()
        IFlyLat.kill()
        IFlyLat = null
    }
}
export default _IFlyLat
